// extracted by mini-css-extract-plugin
export var root = "GenericBlog-root-pshqs";
export var rootCards = "GenericBlog-root_cards-8YDlT";
export var rootHeading = "GenericBlog-root_heading-qu55c";
export var rootLightGray = "GenericBlog-root-lightGray-St8YN";
export var rootWhite = "GenericBlog-root-white-TSKJd";